<div *ngIf="resultsPageGrid && resultsPageGrid?.filtersForm">
  <div class="d-flex flex-wrap">
    <div class="p-2">
      <label>&nbsp;</label>
      <input
        type="text"
        class="form-control"
        [disabled]="gridInProgress"
        [formControl]="resultsPageGrid.filtersForm.get('searchUsers')"
        placeholder="Search"
      />
    </div>
    <!-- <div class="p-2" style="max-width: 125px">
      <label>Platform</label>
      <kendo-dropdownlist [formControl]="resultsPageGrid.filtersForm.get('platform')" [data]="appList"> </kendo-dropdownlist>
    </div>-->
    <div class="p-2" style="max-width: 125px">
      <label>Department</label>
      <kendo-dropdownlist [formControl]="resultsPageGrid.filtersForm.get('department')" [data]="departmentsList"></kendo-dropdownlist>
    </div>
    <div class="p-2">
      <label>Product Status</label>
      <mat-select
        class="multiSelect-control form-control"
        [formControl]="resultsPageGrid.filtersForm.get('prdStatus')"
        multiple
        matTooltip="Select one or more statuses to filter results"
        matTooltipPosition="above"
        placeholder="Select statuses..."
      >
        <mat-option *ngFor="let status of prdStatusList" [value]="status">{{ status }}</mat-option>
      </mat-select>
    </div>
  </div>

  <!-- Loading Indicator -->
  <div *ngIf="gridInProgress" class="d-flex justify-content-center p-3">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <!-- Material Table -->
  <div *ngIf="!gridInProgress && resultsPageGrid" class="stripe-table">
    <table
      mat-table
      [dataSource]="resultsPageGrid.dataSource"
      matSort
      (matSortChange)="resultsPageGrid.onSortChange($event)"
      class="mat-elevation-z1 mat-table mat-small clean-table"
    >
      <!-- ID Column -->
      <ng-container matColumnDef="createdTime">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Created Date</th>
        <td mat-cell *matCellDef="let element">{{ element.createdTime | date : 'dd-MM-yyyy' || '' }}</td>
      </ng-container>

      <!-- Customer Name Column -->
      <ng-container matColumnDef="lastUpdatedTime">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Updated Time</th>
        <td mat-cell *matCellDef="let element">{{ element.lastUpdatedTime | date : 'dd-MM-yyyy' || '' }}</td>
      </ng-container>
      <ng-container matColumnDef="nationalId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>NID</th>
        <td mat-cell *matCellDef="let element">{{ element.customerData.nic || '' }}</td>
      </ng-container>
      <ng-container matColumnDef="boid">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>BOID</th>
        <td mat-cell *matCellDef="let element">{{ element.customerData.boid || '' }}</td>
      </ng-container>
      <ng-container matColumnDef="productType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Product Type</th>
        <td mat-cell *matCellDef="let element">{{ element.productType }}</td>
      </ng-container>
      <ng-container matColumnDef="customerData">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Customer Info</th>
        <td mat-cell *matCellDef="let element" class="user-info">
          {{ element.customerData.displayName || '' }} <br />{{ element.customerData.email || '' }}<br />{{
            element.customerData.mobilePhoneNumber || ''
          }}
        </td>
      </ng-container>

      <!-- Status Column -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Product Status</th>
        <td mat-cell *matCellDef="let element">
          {{ element.status }}
        </td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let element">
          <a
            class="view-more"
            matTooltip="View detailed information"
            matTooltipPosition="above"
            target="_blank"
            routerLink="/super-admin/signup-view/{{ element?.productId }}/{{ element?.customerData?.id }}/basic"
            ><mat-icon>visibility</mat-icon></a
          >
          <!-- <button mat-menu-item (click)="viewDetails(element)" matTooltip="View detailed information" matTooltipPosition="above">
            <mat-icon>visibility</mat-icon>
          </button> -->
        </td>
      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="['createdTime', 'lastUpdatedTime', 'nationalId', 'boid', 'productType', 'customerData', 'status', 'actions']"
      ></tr>
      <!-- <tr
      mat-row
      *matRowDef="
        let row;
        columns: [
          'id',
          'customerName',
          'saleable',
          'avgCost',
          'totalCost',
          'marketRate',
          'marketValue',
          'unrealizedGain',
          'gainPercentage',
          'marketValuePercentage'
        ]
      "
    ></tr> -->
      <tr
        mat-row
        *matRowDef="
          let row;
          columns: ['createdTime', 'lastUpdatedTime', 'nationalId', 'boid', 'productType', 'customerData', 'status', 'actions']
        "
      ></tr>
    </table>

    <!-- No Data Message -->
    <div *ngIf="!gridInProgress && resultsPageGrid && resultsPageGrid.dataSource.data.length === 0" class="text-center p-4">
      <p class="text-muted">No records found</p>
    </div>
    <!-- Paginator -->
    <mat-paginator
      [pageSizeOptions]="[15, 25, 50, 100]"
      [pageSize]="resultsPageGrid.pageSize"
      [length]="resultsPageGrid.total"
      [pageIndex]="resultsPageGrid.pageIndex"
      (page)="resultsPageGrid.onPaginate($event)"
      showFirstLastButtons
    >
    </mat-paginator>
  </div>
</div>
